import { render } from "./UserTask.vue?vue&type=template&id=6c7aed22&scoped=true"
import script from "./UserTask.vue?vue&type=script&lang=js"
export * from "./UserTask.vue?vue&type=script&lang=js"

import "./UserTask.vue?vue&type=style&index=0&id=6c7aed22&scoped=true&lang=scss"

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7aed22"]])

export default __exports__